import {
  boxShadow,
  mediaHelper,
  MINIMUM_FOOTER_HEIGHT_PX,
  paletteHelper,
  SITE_HEADER_HEIGHT_PX,
  spacingHelper,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { SuburbPageBreadCrumbsWithData } from '../components/SuburbPageBreadCrumbs/SuburbPageBreadCrumbs';
import { PageContainer } from '../../components/PageContainer/PageContainer';
import { SuburbPageTitleWithData } from '../components/SuburbPageTitleWithData/SuburbPageTitleWithData';
import { SuburbPagePropertyCollectionBricksWithData } from '../components/SuburbPagePropertyCollectionBricks/SuburbPagePropertyCollectionBricksWithData';
import { SuburbPageNearbyChildcareCentresBrickWithData } from '../components/SuburbPageNearbyChildcareCentresBrick/SuburbPageNearbyChildcareCentresBrick';
import { SuburbPageNearbySchoolsBricksWithData } from '../components/SuburbPageNearbySchoolsBricks/SuburbPageNearbySchoolsBricksWithData';
import { SuburbPageStreetsWithData } from '../components/SuburbPageStreets/SuburbPageStreets';
import { SuburbPageSurroundingSuburbsWithData } from '../components/SuburbPageSurroundingSuburbs/SuburbPageSurroundingSuburbs';
import { SuburbPageSeoFooterWithData } from '../components/SuburbPageSeoFooter/SuburbPageSeoFooter';
import { SuburbPageDemographicsBrickWithData } from '../components/SuburbPageDemographicsBrick/SuburbPageDemographicsBrick';
import { SuburbPageMarketInsightsBrickWithData } from '../components/SuburbPageMarketInsightsBrick/SuburbPageMarketInsightsBrick';
import { SuburbPageVGDisclaimerFooter } from '../components/SuburbPageVGDisclaimerFooter/SuburbPageVGDisclaimerFooter';
import { useFeatureRollout } from '@rea-argonaut/experiment';
import { SuburbPageFlatmatesBrickWithData } from '../components/SuburbPageFlatmatesBrick/SuburbPageFlatmatesBrickWithData';

const ScreenContainer = styled.div`
  margin-top: ${SITE_HEADER_HEIGHT_PX}px;
  min-height: calc(100vh - ${MINIMUM_FOOTER_HEIGHT_PX}px);
  display: flex;
  flex-direction: column;
  background-color: ${paletteHelper('backgroundSecondaryBase')};
`;

const PageHeaderContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border-bottom: 1px solid ${paletteHelper('borderPrimary')};
  padding-bottom: ${spacingHelper('medium')};
  ${boxShadow.headerBoxShadow}
`;

const PageHeaderInnerContainer = styled(PageContainer)`
  padding-top: ${spacingHelper('large')};
  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }
`;

const PageContentContainer = styled(PageContainer)`
  display: flex;
  flex-direction: column;
  row-gap: ${spacingHelper('large')};
  padding: ${spacingHelper('medium')} 0 ${spacingHelper('large')};
  flex-grow: 1;

  ${mediaHelper('tabletMax')} {
    padding: ${spacingHelper('medium')} ${spacingHelper('extraSmall')} ${spacingHelper('large')};
  }
`;

const PageFooterContainer = styled(PageContainer)`
  display: flex;
  flex-direction: column;
  row-gap: ${spacingHelper('large')};
  flex-grow: 1;
`;

export const SuburbPageScreen: FunctionComponent = () => {
  const isFlatmatesBrickEnabled = useFeatureRollout('flatmates_brick_on_suburb_page').isEnabled();
  return (
    <ScreenContainer as="main" id="main-content">
      <PageHeaderContainer>
        <SuburbPageBreadCrumbsWithData />
        <PageHeaderInnerContainer>
          <SuburbPageTitleWithData />
        </PageHeaderInnerContainer>
      </PageHeaderContainer>
      <PageContentContainer>
        <SuburbPageMarketInsightsBrickWithData />
        <SuburbPageDemographicsBrickWithData />
        {isFlatmatesBrickEnabled && <SuburbPageFlatmatesBrickWithData />}
        <SuburbPagePropertyCollectionBricksWithData />
        <SuburbPageNearbyChildcareCentresBrickWithData />
        <SuburbPageNearbySchoolsBricksWithData />
        <SuburbPageStreetsWithData />
        <SuburbPageSurroundingSuburbsWithData />
      </PageContentContainer>
      <PageFooterContainer>
        <SuburbPageVGDisclaimerFooter />
        <SuburbPageSeoFooterWithData />
      </PageFooterContainer>
    </ScreenContainer>
  );
};
